function desktopHeader() {
    // Header hover state
    /* $('.header-main').on('mouseover', function(e) {
        $(this).addClass('is-active');
    })
    $('.header-main').on('mouseleave', function(e) {
        if (! $(e.relatedTarget).is('.js-shop-dropdown, .left-panel__img')) {
            $(this).removeClass('is-active');
        }
    }) */

    // Shop dropdown menu hover states
    $('.js-open-shop-dropdown').on('mouseover', function(e) {
        $('.js-shop-dropdown').addClass('is-active');
    })
    $('.js-open-shop-dropdown').on('mouseleave', function(e) {
        console.log(e.relatedTarget);
        if (! $(e.relatedTarget).is('.js-shop-dropdown, .left-panel__img')) {
            console.log('remove dropdown');
            $('.js-shop-dropdown').removeClass('is-active');
        } else {
            console.log('keep dropdown');
        }
    })
    $('.js-shop-dropdown').on('mouseleave', function(e) {
        if (! $(e.relatedTarget).is('.js-open-shop-dropdown')) {
            $('.js-shop-dropdown').removeClass('is-active');
        }
    })
}

function mobileHeader() {
    $('.js-toggle-mobile-nav').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('has-mobile-nav');
    });

    /* $('.js-modal-menu-toggle-shop').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.modal-menu').toggleClass('shop-open');
    }); */

    $('.js__mobile-menu-expand-trigger').on('click', function(e) {
        $(this).stop().toggleClass('open');
        $(this).siblings('.js__mobile-menu-expand-content').stop().slideToggle();
    });
}